import { format } from "date-fns";

export function formatDate(unixTimeStamp) {
  return format(new Date(unixTimeStamp * 1000), "dd/MM/yyyy HH:mm");
}

export function inputDate(unixTimeStamp) {
  return format(new Date(unixTimeStamp * 1000), "yyyy-MM-dd'T'hh:mm:ss");
}